import axios from 'axios';

const API_URL = process.env.VUE_APP_CORE_API;

export class Http {
  constructor(meta) {
    this.isAuth = meta && meta.auth ? meta.auth : true;
    this.instance = axios.create({
      baseURL: meta && meta.base_url ? API_URL : `${API_URL}/`
    });

    return this.init();
  }

  init() {
    if (this.isAuth) {
      this.instance.interceptors.request.use(
        request => {
          request.headers.authorization =
            'Bearer ' + localStorage.getItem('api_token');

          return request;
        },
        error => {
          return Promise.reject(error);
        }
      );
    }

    this.instance.interceptors.request.use(request => {
      if (request.data instanceof FormData) {
        if (request.method === 'patch') {
          request.method = 'post';
          request.data.set('_method', 'PATCH');
        }

        Object.assign(request.headers, {
          'Content-Type': 'multipart/form-data'
        });
      }

      return request;
    });

    return this.instance;
  }
}
